<template>
    <div class="tyn-root">
        <Header />
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="sa" :style="{ '--sa-colunas': colunas }">
                        <section class="sa-hero">
                            <div class="sa-hero-titulos">
                                <h1 class="sa-hero-titulo">{{ tituloPagina }}</h1>
                                <p class="sa-hero-sub">{{ subtitulo }}</p>
                            </div>
                            <label class="sa-busca">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                                <span class="sa-sr">Buscar trilhas por nome ou descrição</span>
                                <input :value="pagFilter"
                                       type="search"
                                       placeholder="Buscar por nome ou descrição"
                                       @input="aoBuscar($event.target.value)" />
                            </label>
                        </section>

                        <div class="sa-filtros">
                            <div ref="dropdownRef" class="sa-dd">
                                <button type="button"
                                        class="sa-dd-botao"
                                        :class="{ 'is-aberto': dropdownAberto }"
                                        aria-haspopup="listbox"
                                        :aria-expanded="dropdownAberto"
                                        @click="alternarDropdown"
                                        @keydown.down.prevent="abrirDropdown">
                                    <span class="sa-dd-rotulo">Categoria</span>
                                    <span class="sa-ponto" :style="{ background: opcaoAtual.cor }"></span>
                                    <span class="sa-dd-valor">{{ opcaoAtual.titulo }}</span>
                                    <span v-if="opcaoAtual.total != null" class="sa-num">{{ opcaoAtual.total }}</span>
                                    <svg class="sa-dd-seta" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
                                </button>

                                <div v-if="dropdownAberto"
                                     ref="listaRef"
                                     class="sa-dd-lista"
                                     role="listbox"
                                     aria-label="Categorias"
                                     @keydown="onTeclaLista">
                                    <button v-for="(c, i) in opcoesCategoria"
                                            :key="c.id == null ? 'todas' : c.id"
                                            type="button"
                                            role="option"
                                            class="sa-dd-opcao"
                                            :class="{ 'is-selecionada': c.id === idCategoria }"
                                            :aria-selected="c.id === idCategoria"
                                            :tabindex="i === indiceFoco ? 0 : -1"
                                            @click="escolherCategoria(c.id)">
                                        <span class="sa-ponto" :style="{ background: c.cor }"></span>
                                        <span class="sa-dd-opcao-nome">{{ c.titulo }}</span>
                                        <span v-if="c.total != null" class="sa-dd-opcao-num">{{ c.total }}</span>
                                        <svg class="sa-dd-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
                                    </button>
                                </div>
                            </div>

                            <label class="sa-ordem">
                                Ordenar
                                <select v-model="ordenacao" @change="aplicarOrdenacao">
                                    <option value="nome">Nome (A–Z)</option>
                                    <option value="recentes">Mais recentes</option>
                                </select>
                            </label>

                            <span class="sa-espaco"></span>

                            <button v-if="temFiltros" type="button" class="sa-limpar" @click="limparFiltros">
                                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
                                Limpar filtros
                            </button>
                        </div>

                        <main class="sa-main">
                            <div ref="gradeRef" class="sa-area">
                                <div v-if="isLoading" class="sa-vazio">
                                    <strong>Carregando trilhas…</strong>
                                </div>

                                <ul v-else-if="trilhas.length" class="sa-grade">
                                    <li v-for="trilha in trilhas" :key="trilha.idTreinamento">
                                        <button type="button" class="sa-card" @click="abrirModal(trilha)">
                                            <span class="sa-capa" :style="tom(trilha)">
                                                <img v-if="!semImagem(trilha)" :src="trilha.urlFoto" alt="" @error="onErroImagem(trilha)" />
                                                <svg v-else class="sa-capa-icone" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H2Z" /><path d="M22 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8Z" /></svg>
                                            </span>
                                            <span class="sa-card-corpo">
                                                <span v-if="nomeCategoria(trilha.idCategoria)"
                                                      class="sa-card-cat"
                                                      :style="{ color: corCategoria(trilha.idCategoria) }">{{ nomeCategoria(trilha.idCategoria) }}</span>
                                                <span class="sa-card-titulo">{{ trilha.nmTreinamento }}</span>
                                                <span v-if="trilha.dsTreinamento" class="sa-card-desc">{{ trilha.dsTreinamento }}</span>
                                                <span v-if="trilha.nmAutor" class="sa-card-rodape">
                                                    <span class="sa-card-autor">{{ trilha.nmAutor }}</span>
                                                </span>
                                            </span>
                                        </button>
                                    </li>
                                </ul>

                                <div v-else class="sa-vazio">
                                    <span class="sa-vazio-icone">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
                                    </span>
                                    <strong>Nenhuma trilha encontrada</strong>
                                    <span>Tente outro termo ou procure em todas as categorias.</span>
                                    <button type="button" class="sa-btn" @click="limparFiltros">Limpar filtros</button>
                                </div>
                            </div>

                            <nav class="sa-paginacao" aria-label="Paginação">
                                <template v-if="totalPages > 1">
                                    <button type="button" class="sa-pag" aria-label="Página anterior" :disabled="currentPage === 0" @click="previousPage">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6" /></svg>
                                    </button>
                                    <template v-for="(p, i) in paginasVisiveis">
                                        <span v-if="p === '…'" :key="'e' + i" class="sa-pag-reticencias">…</span>
                                        <button v-else
                                                :key="'p' + i"
                                                type="button"
                                                class="sa-pag"
                                                :class="{ 'is-atual': p === currentPage + 1 }"
                                                :aria-current="p === currentPage + 1 ? 'page' : null"
                                                @click="goToPage(p - 1)">{{ p }}</button>
                                    </template>
                                    <button type="button" class="sa-pag" aria-label="Próxima página" :disabled="!temProximaPagina" @click="nextPage">
                                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                                    </button>
                                </template>
                            </nav>
                        </main>

                        <footer class="sa-rodape">
                            <span>Soll Academy · SollAi</span>
                            <span>Dúvidas? Fale com nossa equipe</span>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
        <ModalTrilha :trilhaSelecionada="trilhaSelecionada"
                     @fechar="trilhaSelecionada = null" />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import ModalTrilha from '@/components/SollAcademy/ModalTrilha.vue'
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'

    const CORES = ['#2563eb', '#7c3aed', '#0891b2', '#d97706', '#059669', '#db2777', '#4f46e5', '#0d9488']
    const GAP = 16
    const LINHAS = 2

    export default {
        components: { Header, ModalTrilha },
        name: 'SollAcademyTrilhas',
        data() {
            return {
                trilhas: [],
                categorias: [],
                qtdRegistros: 0,
                currentPage: 0,
                colunas: 7,
                larguraMinCard: 220,
                maxColunas: 7,
                idCategoria: null,
                pagFilter: '',
                ordenacao: 'nome',
                debounceTimeout: null,
                trilhaSelecionada: null,
                isLoading: false,
                imagensComErro: new Set(),
                dropdownAberto: false,
                indiceFoco: 0,
                resizeObserver: null,
                requisicao: 0,
            }
        },
        computed: {
            pageSize() {
                return this.colunas * LINHAS
            },

            opcoesCategoria() {
                const totalAtual = this.qtdRegistros
                return [
                    {
                        id: null,
                        titulo: 'Todas as categorias',
                        cor: '#0f172a',
                        total: this.idCategoria == null ? totalAtual : null,
                    },
                    ...(this.categorias || []).map((c, i) => {
                        const id = Number(c.idCategoria)
                        return {
                            id,
                            titulo: c.nmCategoria,
                            cor: CORES[i % CORES.length],
                            total: Number(this.idCategoria) === id ? totalAtual : null,
                        }
                    }),
                ]
            },

            opcaoAtual() {
                return this.opcoesCategoria.find(c => c.id === this.idCategoria) || this.opcoesCategoria[0]
            },

            tituloPagina() {
                return this.idCategoria == null ? 'Todas as trilhas' : this.opcaoAtual.titulo
            },

            subtitulo() {
                const n = this.qtdRegistros || 0
                const termo = (this.pagFilter || '').trim()
                let texto = `${n} ${n === 1 ? 'trilha' : 'trilhas'}`
                if (termo) texto += ` para "${termo}"`
                texto += this.idCategoria == null ? ' no catálogo da Soll Academy' : ' nesta categoria'
                return texto
            },

            temFiltros() {
                return this.idCategoria != null || !!(this.pagFilter || '').trim()
            },

            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize) || 0
            },

            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages
            },

            paginasVisiveis() {
                const n = this.totalPages
                const p = this.currentPage + 1
                if (n <= 1) return []
                if (n <= 7) return Array.from({ length: n }, (_, i) => i + 1)
                const conjunto = new Set([1, n, p - 1, p, p + 1].filter(x => x >= 1 && x <= n))
                const ordenadas = [...conjunto].sort((a, b) => a - b)
                const out = []
                ordenadas.forEach((x, i) => {
                    if (i && x - ordenadas[i - 1] > 1) out.push('…')
                    out.push(x)
                })
                return out
            },
        },
        methods: {
            load() {
                this.getCategorias()
                this.getTrilhas()
            },

            getCategorias() {
                axios.get(`${urlApi}/SollAcademy/GetCategorias`)
                    .then(res => {
                        if (res.data.success) {
                            this.categorias = res.data.data.rows.map(r => r.item)
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        console.error('Erro ao fazer requisição:', err)
                        avisoToast('Erro ao carregar categorias!', 'warning')
                    })
            },

            mapOrderBy(key) {
                switch (key) {
                    case 'recentes':
                        return 'tbAcdTreinamentos.dtAlteracao DESC, tbAcdTreinamentos.dtInclusao DESC'
                    case 'nome':
                        return 'tbAcdTreinamentos.nmTreinamento ASC'
                    default:
                        return null
                }
            },

            aplicarOrdenacao() {
                this.currentPage = 0
                this.getTrilhas()
            },

            aoBuscar(valor) {
                this.pagFilter = valor
                clearTimeout(this.debounceTimeout)
                this.debounceTimeout = setTimeout(() => {
                    this.currentPage = 0
                    this.atualizarRota()
                    this.getTrilhas()
                }, 400)
            },

            escolherCategoria(id) {
                this.idCategoria = id
                this.currentPage = 0
                this.fecharDropdown()
                this.atualizarRota()
                this.getTrilhas()
            },

            limparFiltros() {
                this.pagFilter = ''
                this.idCategoria = null
                this.currentPage = 0
                this.fecharDropdown(false)
                this.atualizarRota()
                this.getTrilhas()
            },

            atualizarRota() {
                const query = {}
                if (this.idCategoria != null) query.categoria = this.idCategoria
                const termo = (this.pagFilter || '').trim()
                if (termo) query.q = termo
                this.$router.replace({ name: 'SollAcademyTrilhas', query }).catch(() => {})
            },

            getTrilhas() {
                this.isLoading = true
                this.requisicao += 1
                const requisicao = this.requisicao
                const params = {
                    index: this.currentPage,
                    take: this.pageSize,
                    filter: this.pagFilter,
                    idCategoria: this.idCategoria,
                }
                const orderBy = this.mapOrderBy(this.ordenacao)
                if (orderBy) params.orderBy = orderBy

                axios.get(`${urlApi}/SollAcademy/GetTreinamentos`, { params })
                    .then(res => {
                        if (requisicao !== this.requisicao) return
                        if (res.data.success) {
                            this.trilhas = res.data.data.rows.map(r => {
                                const item = r.item
                                item.urlFoto = item.urlFoto || 'img-default-curso.png'
                                return item
                            })
                            this.qtdRegistros = res.data.data.qtdRecords
                            const paginas = Math.ceil(this.qtdRegistros / this.pageSize) || 0
                            if (this.currentPage > 0 && this.currentPage >= paginas) {
                                this.currentPage = Math.max(0, paginas - 1)
                                this.getTrilhas()
                            }
                        } else {
                            console.warn('Resposta sem sucesso')
                        }
                    })
                    .catch(err => {
                        if (requisicao !== this.requisicao) return
                        console.error('Erro ao carregar trilhas:', err)
                        avisoToast('Erro ao carregar trilhas!', 'warning')
                    })
                    .finally(() => {
                        if (requisicao === this.requisicao) this.isLoading = false
                    })
            },

            abrirModal(trilha) {
                this.trilhaSelecionada = trilha
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--
                    this.getTrilhas()
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++
                    this.getTrilhas()
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex
                    this.getTrilhas()
                }
            },

            observarGrade() {
                const el = this.$refs.gradeRef
                if (!el || typeof ResizeObserver === 'undefined') return
                this.resizeObserver = new ResizeObserver(([entrada]) => {
                    const largura = entrada.contentRect.width
                    if (!largura) return
                    const colunas = Math.max(1, Math.min(this.maxColunas, Math.floor((largura + GAP) / (this.larguraMinCard + GAP))))
                    if (colunas === this.colunas) return
                    this.colunas = colunas
                    this.currentPage = 0
                    this.getTrilhas()
                })
                this.resizeObserver.observe(el)
            },

            alternarDropdown() {
                if (this.dropdownAberto) this.fecharDropdown()
                else this.abrirDropdown()
            },

            abrirDropdown() {
                this.dropdownAberto = true
                const indice = this.opcoesCategoria.findIndex(c => c.id === this.idCategoria)
                this.indiceFoco = Math.max(0, indice)
                this.$nextTick(() => this.focarOpcao())
            },

            fecharDropdown(devolverFoco) {
                this.dropdownAberto = false
                if (devolverFoco === false) return
                const raiz = this.$refs.dropdownRef
                const botao = raiz && raiz.querySelector('.sa-dd-botao')
                if (botao) botao.focus()
            },

            focarOpcao() {
                const lista = this.$refs.listaRef
                if (!lista) return
                const opcoes = lista.querySelectorAll('[role="option"]')
                const alvo = opcoes[this.indiceFoco]
                if (alvo) alvo.focus()
            },

            onTeclaLista(e) {
                const n = this.opcoesCategoria.length
                if (e.key === 'ArrowDown') {
                    e.preventDefault()
                    this.indiceFoco = (this.indiceFoco + 1) % n
                    this.focarOpcao()
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault()
                    this.indiceFoco = (this.indiceFoco - 1 + n) % n
                    this.focarOpcao()
                } else if (e.key === 'Home') {
                    e.preventDefault()
                    this.indiceFoco = 0
                    this.focarOpcao()
                } else if (e.key === 'End') {
                    e.preventDefault()
                    this.indiceFoco = n - 1
                    this.focarOpcao()
                } else if (e.key === 'Escape') {
                    e.preventDefault()
                    this.fecharDropdown()
                } else if (e.key === 'Tab') {
                    this.fecharDropdown(false)
                }
            },

            fecharAoClicarFora(e) {
                const raiz = this.$refs.dropdownRef
                if (this.dropdownAberto && raiz && !raiz.contains(e.target)) this.fecharDropdown(false)
            },

            nomeCategoria(id) {
                const cat = (this.categorias || []).find(c => Number(c.idCategoria) === Number(id))
                return cat ? cat.nmCategoria : ''
            },

            corCategoria(id) {
                const indice = (this.categorias || []).findIndex(c => Number(c.idCategoria) === Number(id))
                return CORES[(indice < 0 ? 0 : indice) % CORES.length]
            },

            tom(trilha) {
                const tons = [
                    ['#e0e7ff', '#4338ca'],
                    ['#dcfce7', '#15803d'],
                    ['#fef3c7', '#b45309'],
                    ['#fce7f3', '#be185d'],
                    ['#e0f2fe', '#0369a1'],
                ]
                const chave = String(trilha && (trilha.idTreinamento || trilha.nmTreinamento) || '')
                let h = 0
                for (const ch of chave) h = (h * 31 + ch.charCodeAt(0)) >>> 0
                const par = tons[h % tons.length]
                return { '--sa-ph-bg': par[0], '--sa-ph-fg': par[1] }
            },

            semImagem(trilha) {
                const url = trilha && trilha.urlFoto
                if (!url) return true
                return this.imagensComErro.has(url)
            },

            onErroImagem(trilha) {
                if (!trilha || !trilha.urlFoto) return
                const s = new Set(this.imagensComErro)
                s.add(trilha.urlFoto)
                this.imagensComErro = s
            },
        },

        mounted() {
            const categoriaSelecionada = this.$route.query.categoria
            if (categoriaSelecionada) {
                const id = parseInt(categoriaSelecionada, 10)
                this.idCategoria = Number.isNaN(id) ? null : id
            }
            if (this.$route.query.q) this.pagFilter = String(this.$route.query.q)
            this.load()
            this.$nextTick(() => this.observarGrade())
            document.addEventListener('pointerdown', this.fecharAoClicarFora)
        },

        beforeDestroy() {
            clearTimeout(this.debounceTimeout)
            if (this.resizeObserver) this.resizeObserver.disconnect()
            document.removeEventListener('pointerdown', this.fecharAoClicarFora)
        },
    }
</script>

<style scoped>
.sa {
  --sa-azul-escuro: #0b1f4d;
  --sa-primaria: #2563eb;
  --sa-link: #1d4ed8;
  --sa-sucesso: #059669;
  --sa-texto: #0f172a;
  --sa-texto-2: #334155;
  --sa-texto-3: #475569;
  --sa-muted: #64748b;
  --sa-borda: #e2e8f0;
  --sa-fundo: #f4f6fa;
  --sa-gutter: 40px;
  --sa-card-h: 316px;
  --sa-gap: 16px;

  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--sa-fundo);
  font-family: 'Poppins', system-ui, sans-serif;
  color: var(--sa-texto);
}

.sa svg { width: 18px; height: 18px; flex-shrink: 0; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
.sa button, .sa select, .sa input { font: inherit; }
.sa button { color: inherit; }
.sa button:focus-visible, .sa input:focus-visible, .sa select:focus-visible { outline: 2px solid var(--sa-primaria); outline-offset: 2px; }
.sa-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
.sa-ponto { width: 8px; height: 8px; flex-shrink: 0; border-radius: 999px; }
.sa-num { font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 999px; background: #f1f5f9; color: var(--sa-texto-3); font-variant-numeric: tabular-nums; }

.sa-hero {
  display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 720px); gap: 40px; align-items: center;
  padding: 22px var(--sa-gutter);
  background: var(--sa-azul-escuro); color: #fff;
}
.sa-hero-titulos { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.sa-hero-titulo { margin: 0; font-size: 24px; line-height: 1.3; font-weight: 700; color: #fff !important; background: none; -webkit-text-fill-color: #fff; }
.sa-hero-sub { margin: 0; font-size: 14px; line-height: 1.5; color: #cbd5e1; }
.sa-busca { position: relative; display: flex; align-items: center; }
.sa-busca svg { position: absolute; left: 16px; color: var(--sa-muted); pointer-events: none; }
.sa-busca input {
  width: 100%; height: 48px; box-sizing: border-box; padding: 0 16px 0 46px;
  border: 0; border-radius: 12px; background: #fff; color: var(--sa-texto); font-size: 14px;
}

.sa-filtros {
  position: sticky; top: var(--appbar-height, 65px); z-index: 5;
  height: 64px; box-sizing: border-box; flex-shrink: 0;
  display: flex; align-items: center; gap: 12px;
  padding: 0 var(--sa-gutter);
  background: #fff; border-bottom: 1px solid var(--sa-borda);
}
.sa-espaco { flex-grow: 1; }

.sa-dd { position: relative; flex-shrink: 0; }
.sa-dd-botao {
  width: 340px; height: 40px; box-sizing: border-box; padding: 0 12px;
  display: flex; align-items: center; gap: 10px;
  border: 1px solid var(--sa-borda); border-radius: 10px; background: #fff;
  text-align: left; cursor: pointer; transition: border-color 0.15s;
}
.sa-dd-botao:hover { border-color: #cbd5e1; }
.sa-dd-botao.is-aberto { border-color: var(--sa-primaria); }
.sa-dd-rotulo { font-size: 13px; color: var(--sa-muted); }
.sa-dd-valor { flex-grow: 1; min-width: 0; font-size: 13px; font-weight: 600; color: var(--sa-texto); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sa-dd-seta { width: 16px !important; height: 16px !important; color: var(--sa-muted); transition: transform 0.15s; }
.sa-dd-botao.is-aberto .sa-dd-seta { transform: rotate(180deg); }

.sa-dd-lista {
  position: absolute; left: 0; top: calc(100% + 6px); z-index: 10;
  width: 340px; max-height: 380px; overflow-y: auto; box-sizing: border-box; padding: 6px;
  background: #fff; border: 1px solid var(--sa-borda); border-radius: 12px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
}
.sa-dd-opcao {
  width: 100%; min-height: 40px; padding: 8px 10px;
  display: flex; align-items: center; gap: 10px;
  border: 0; border-radius: 8px; background: transparent; text-align: left; cursor: pointer;
}
.sa-dd-opcao:hover, .sa-dd-opcao:focus-visible { background: #f1f5f9; outline: none; }
.sa-dd-opcao.is-selecionada { background: #eff4ff; }
.sa-dd-opcao-nome { flex-grow: 1; font-size: 13px; font-weight: 500; color: var(--sa-texto); line-height: 1.35; }
.sa-dd-opcao.is-selecionada .sa-dd-opcao-nome { font-weight: 600; }
.sa-dd-opcao-num { font-size: 12px; color: var(--sa-muted); font-variant-numeric: tabular-nums; }
.sa-dd-check { width: 16px !important; height: 16px !important; stroke-width: 2.4 !important; color: var(--sa-link); opacity: 0; }
.sa-dd-opcao.is-selecionada .sa-dd-check { opacity: 1; }

.sa-ordem {
  height: 40px; box-sizing: border-box; padding: 0 12px; flex-shrink: 0;
  display: flex; align-items: center; gap: 8px;
  border: 1px solid var(--sa-borda); border-radius: 10px; background: #fff;
  font-size: 13px; color: var(--sa-muted);
}
.sa-ordem select { border: 0; background: transparent; font-size: 13px; font-weight: 600; color: var(--sa-texto); cursor: pointer; }

.sa-limpar {
  height: 40px; padding: 0 12px; flex-shrink: 0;
  display: inline-flex; align-items: center; gap: 6px;
  border: 0; border-radius: 10px; background: transparent; color: var(--sa-link) !important;
  font-size: 13px; font-weight: 600; cursor: pointer;
}
.sa-limpar svg { width: 14px; height: 14px; stroke-width: 2.4; }
.sa-limpar:hover { background: #eff4ff; }

.sa-main { flex-grow: 1; display: flex; flex-direction: column; gap: 20px; padding: 24px var(--sa-gutter) 32px; }

.sa-area { height: calc(var(--sa-card-h) * 2 + var(--sa-gap)); }
.sa-grade {
  list-style: none; margin: 0; padding: 0; height: 100%;
  display: grid; gap: var(--sa-gap);
  grid-template-columns: repeat(var(--sa-colunas), minmax(0, 1fr));
  grid-template-rows: repeat(2, var(--sa-card-h));
}
.sa-grade > li { display: flex; min-height: 0; }

.sa-card {
  width: 100%; box-sizing: border-box; padding: 0;
  display: flex; flex-direction: column;
  background: #fff; border: 1px solid var(--sa-borda); border-radius: 12px; overflow: hidden;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
  text-align: left; color: var(--sa-texto) !important; cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, border-color 0.15s;
}
.sa-card:hover { transform: translateY(-2px); border-color: #c7d2fe; box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08); }
.sa-capa {
  position: relative; aspect-ratio: 16 / 9; flex-shrink: 0; overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  background: var(--sa-ph-bg, #e2e8f0); color: var(--sa-ph-fg, #475569);
}
.sa-capa img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.sa-capa-icone { width: 32px !important; height: 32px !important; stroke-width: 1.6 !important; }

.sa-card-corpo { flex-grow: 1; min-height: 0; display: flex; flex-direction: column; gap: 6px; padding: 12px 14px 14px; }
.sa-card-cat { font-size: 11px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sa-card-titulo { font-size: 14px; font-weight: 600; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.sa-card-desc { font-size: 13px; line-height: 1.5; color: var(--sa-muted); display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.sa-card-rodape {
  margin-top: auto; padding-top: 10px; border-top: 1px solid #f1f5f9;
  display: flex; justify-content: space-between; gap: 8px; font-size: 12px; color: var(--sa-muted);
}
.sa-card-autor { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.sa-vazio {
  height: 100%; box-sizing: border-box;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px;
  text-align: center; font-size: 13px; line-height: 1.55; color: var(--sa-muted);
  background: #fff; border: 1px dashed #cbd5e1; border-radius: 16px;
}
.sa-vazio strong { font-size: 15px; color: var(--sa-texto-2); }
.sa-vazio > span:not(.sa-vazio-icone) { max-width: 360px; }
.sa-vazio-icone { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; background: #f1f5f9; }
.sa-vazio-icone svg { width: 24px; height: 24px; stroke-width: 1.8; }
.sa-btn {
  margin-top: 6px; height: 40px; padding: 0 16px;
  border: 1px solid var(--sa-borda); border-radius: 10px; background: #fff; color: var(--sa-texto-2) !important;
  font-size: 13px; font-weight: 600; cursor: pointer;
}
.sa-btn:hover { background: #f8fafc; }

.sa-paginacao { height: 44px; display: flex; align-items: center; justify-content: center; gap: 6px; }
.sa-pag {
  min-width: 40px; height: 40px; padding: 0 10px; box-sizing: border-box;
  display: inline-flex; align-items: center; justify-content: center;
  border: 1px solid var(--sa-borda); border-radius: 10px; background: #fff; color: var(--sa-texto-2) !important;
  font-size: 14px; font-weight: 600; cursor: pointer; font-variant-numeric: tabular-nums;
}
.sa-pag svg { width: 16px; height: 16px; }
.sa-pag:hover:not(:disabled) { background: #f8fafc; }
.sa-pag:disabled { opacity: 0.45; cursor: not-allowed; }
.sa-pag.is-atual { background: var(--sa-azul-escuro); border-color: var(--sa-azul-escuro); color: #fff !important; }
.sa-pag-reticencias { min-width: 24px; text-align: center; color: var(--sa-muted); }

.sa-rodape {
  display: flex; justify-content: space-between; gap: 16px;
  margin-top: auto;
  padding: 22px var(--sa-gutter);
  background: var(--sa-azul-escuro); color: #94a3b8; font-size: 12px;
}

.tyn-content,
.tyn-main,
.tyn-section {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    background: var(--sa-fundo, #f4f6fa);
}
.sa { flex: 1 1 auto; }

@media (max-width: 1440px) { .sa { --sa-gutter: 32px; } }
@media (max-width: 1100px) {
  .sa-hero { grid-template-columns: minmax(0, 1fr); gap: 16px; }
}
@media (max-width: 760px) {
  .sa { --sa-gutter: 16px; }
  .sa-filtros { height: auto; flex-wrap: wrap; padding-top: 12px; padding-bottom: 12px; }
  .sa-dd, .sa-dd-botao, .sa-dd-lista { width: 100%; }
  .sa-ordem { flex-grow: 1; }
  .sa-espaco { display: none; }
  .sa-area { height: auto; min-height: 320px; }
  .sa-grade { grid-template-rows: none; grid-auto-rows: var(--sa-card-h); }
}

[data-bs-theme="dark"] .sa {
    --sa-texto: #e2e8f0;
    --sa-texto-2: #cbd5e1;
    --sa-texto-3: #94a3b8;
    --sa-muted: #94a3b8;
    --sa-borda: rgba(148, 163, 184, 0.24);
    --sa-fundo: transparent;
}
[data-bs-theme="dark"] .sa-filtros,
[data-bs-theme="dark"] .sa-dd-botao,
[data-bs-theme="dark"] .sa-dd-lista,
[data-bs-theme="dark"] .sa-ordem,
[data-bs-theme="dark"] .sa-card,
[data-bs-theme="dark"] .sa-pag,
[data-bs-theme="dark"] .sa-vazio,
[data-bs-theme="dark"] .sa-btn {
    background: #1e293b;
}
[data-bs-theme="dark"] .sa-dd-opcao:hover,
[data-bs-theme="dark"] .sa-dd-opcao:focus-visible,
[data-bs-theme="dark"] .sa-limpar:hover { background: rgba(148, 163, 184, 0.12); }
[data-bs-theme="dark"] .sa-dd-opcao.is-selecionada { background: rgba(37, 99, 235, 0.22); }
[data-bs-theme="dark"] .sa-num,
[data-bs-theme="dark"] .sa-vazio-icone { background: rgba(148, 163, 184, 0.12); color: #cbd5e1; }
[data-bs-theme="dark"] .sa-busca input { color: #0f172a; }
</style>
